import * as _4 from 'lodash4';
import { IMajorCourseMap } from '../../data/builders/major_course_map_program_builder';
import { MajorProgram } from '../../data/builders/major_programs_builder';
import { MajorCourseMapQuery } from '../../data/queries/major_course_map_query';
import { ICourse } from '../../major_explorer_interface';

export class MajorCourseMapViewContentController {
  private major: MajorProgram;
  private courseMap: IMajorCourseMap[];

  constructor(private ngMajorCourseMapQuery: MajorCourseMapQuery) {
    this.courseMap = this.ngMajorCourseMapQuery.result;
  }

  isCourseMapEmpty(): boolean {
    return _4.isEmpty(this.courseMap);
  }

  getCourseCode(course: ICourse): string {
    return !_4.isEmpty(course.code) ? `${course.code} ` : ``;
  }
}

export class MajorCourseMapViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_coursemap_view_content/major_coursemap_view_content.html';
  public controller: any = MajorCourseMapViewContentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    major: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_coursemap_view_content/major_coursemap_view_content_controller.ts